import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52df7f62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "initialLetterCalss + '__list'" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ・")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("集英社ID利用規約")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ・")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www2.shueisha.co.jp/privacy/privacy.html",
  class: "c-link",
  target: "_blank"
}, "集英社プライバシーガイドライン", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ・年末年始 集英社マンガ祭 特設サイト（")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://shueisha-mangasai.jp/index.html",
  class: "c-link",
  target: "_blank"
}, "応募要項", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("、")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://shueisha-mangasai.jp/precautions/",
  class: "c-link",
  target: "_blank"
}, "応募のご注意", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("） ")
const _hoisted_12 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" ・")
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      class: _normalizeClass(_ctx.initialLetterCalss + '__listitem')
    }, [
      _hoisted_2,
      _createVNode(_component_router_link, {
        tag: "a",
        to: { name: 'Terms' },
        class: "c-link",
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("li", {
      class: _normalizeClass(_ctx.initialLetterCalss + '__listitem')
    }, _hoisted_6, 2),
    (_ctx.linkageInfo.linkageId === _ctx.MANGASAI_LINKAGE_ID)
      ? (_openBlock(), _createElementBlock("li", {
          key: 0,
          class: _normalizeClass(_ctx.initialLetterCalss + '__listitem')
        }, _hoisted_12, 2))
      : (_ctx.serviceTermUrl)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: _normalizeClass(_ctx.initialLetterCalss + '__listitem')
          }, [
            _hoisted_13,
            _createElementVNode("a", {
              href: _ctx.serviceTermUrl,
              class: "c-link",
              target: "_blank"
            }, _toDisplayString(_ctx.serviceName) + "会員規約", 9, _hoisted_14)
          ], 2))
        : _createCommentVNode("", true)
  ]))
}